module.exports = require("./lib-cov/filtr");